<div class="modal-header">
	<h4 class="modal-title">
		<i
			class="bi bi-file-earmark-pdf text-danger me-2"
			*ngIf="previewMode === 'pdf'"
		></i>
		<i
			class="bi bi-file-earmark-text text-primary me-2"
			*ngIf="previewMode === 'content'"
		></i>
		<!-- {{ previewMode === "pdf" ? "PDF-esikatselu" : "Sisällön esikatselu" }} -->
		Tallenna haettu materiaali
	</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="dismiss()"
	></button>
</div>

<div class="modal-body">
	<!-- Loading state -->
	<div *ngIf="isLoading" class="text-center py-4">
		<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Ladataan PDF-sisältöä...</span>
		</div>
		<p class="mt-3 text-muted">Lukee PDF-sisältöä...</p>
	</div>

	<!-- Error state -->
	<div *ngIf="loadingError && !isLoading" class="alert alert-warning">
		<i class="bi bi-exclamation-triangle me-2"></i>
		{{ loadingError }}
		<p class="mb-0 mt-2 small">
			Voit silti jatkaa lataamista, mutta esikatselua ei voida näyttää.
		</p>
	</div>

	<!-- Content preview -->
	<div *ngIf="!isLoading && !loadingError">
		<!-- PDF Info -->
		<div class="pdf-info mb-4">
			<div class="row">
				<div class="col-9">
					<label class="form-label fw-bold mb-2"> Nimi </label>
					<p *ngIf="previewMode === 'pdf'" class="mb-1 fw-medium">
						{{ filename }}
					</p>
					<div *ngIf="previewMode === 'content'" class="mb-2">
						<div class="input-group">
							<input
								type="text"
								class="form-control"
								[(ngModel)]="customFilename"
								placeholder="Anna PDF-tiedoston nimi"
								maxlength="100"
								[disabled]="isApproving"
							/>
							<span
								*ngIf="domainSuffix"
								class="input-group-text text-muted small"
							>
								{{ domainSuffix }}
							</span>
						</div>
						<small
							class="form-text text-muted d-flex align-items-center gap-1"
							placement="top"
							style="cursor: help"
						>
							<i
								class="bi bi-question-circle"
								style="font-size: 0.9rem"
							></i>
							Tiedostonimi ei voi sisältää merkkejä: &lt; &gt; " \
							/ | ? *
							<span *ngIf="domainSuffix" class="ms-2">
								Lähteen verkkosivusto lisätään automaattisesti.
							</span>
						</small>
					</div>
				</div>
				<div class="col text-center">
					<label class="form-label fw-bold mb-2">{{
						previewMode === "pdf" ? "Koko" : "Arvioitu koko"
					}}</label>
					<p class="mb-1">
						{{
							previewMode === "pdf"
								? fileSize
								: estimatedFileSize || "Laskee..."
						}}
					</p>
				</div>
				<div class="col-2" *ngIf="previewMode === 'pdf'">
					<label class="form-label fw-bold mb-2">Sivuja</label>
					<p class="mb-1">{{ totalPages || "Tuntematon" }}</p>
				</div>
			</div>
			<!-- <div class="row" *ngIf="title">
				<div class="col-12">
					<small class="text-muted">Otsikko:</small>
					<p class="mb-1">{{ title }}</p>
				</div>
			</div> -->
		</div>

		<hr class="my-3" />

		<!-- Text Content Preview -->
		<div class="pdf-info mb-4">
			<!-- <h6 class="form-label fw-bold mb-3 d-flex align-items-center gap-2">
				<i class="bi bi-file-text"></i>
				Tarkista sisältö
			</h6> -->
			<label class="form-label fw-bold mb-2"> Tarkista sisältö </label>

			<div class="content-preview-area">
				<pre class="preview-text">{{ getCombinedTextContent() }}</pre>
			</div>
		</div>

		<!-- Images Preview -->
		<div *ngIf="hasImages()" class="images-preview">
			<h6 class="form-label fw-bold mb-3 d-flex align-items-center gap-2">
				<i class="bi bi-images"></i>
				Kuvat ({{ imageArticles.length }} kpl)
			</h6>
			<div class="row g-2">
				<div
					*ngFor="let image of getPreviewImages(); let i = index"
					class="col-4"
				>
					<div class="image-preview-card">
						<div
							class="image-placeholder d-flex align-items-center justify-content-center"
						>
							<i class="bi bi-image text-muted"></i>
							<span class="ms-2 small text-muted"
								>Kuva {{ i + 1 }}</span
							>
						</div>
						<small class="image-title">{{ image.title }}</small>
					</div>
				</div>
			</div>
			<small class="text-muted" *ngIf="imageArticles.length > 3">
				...ja {{ imageArticles.length - 3 }} kuvaa lisää
			</small>
		</div>
	</div>

	<!-- PDF Download Button (only shown in content preview mode) -->
	<!-- <div *ngIf="previewMode === 'content'" class="text-center mt-4">
		<button
			type="button"
			class="btn btn-primary"
			(click)="downloadPDF()"
			[disabled]="
				isLoading || isApproving || (!pdfBlob && !contentPreview)
			"
			title="Avaa PDF tarkistettavaksi"
		>
			<i class="bi bi-eye me-2"></i>
			Tarkista tiedosto
		</button>
		<p class="text-muted small mt-2 mb-0 text-start">
			Sisältö muunnettiin PDF-tiedostoksi. Tarkista ennen jatkamista.
		</p>
	</div> -->
</div>

<div class="modal-footer">
	<button
		type="button"
		class="btn btn-outline-primary"
		(click)="cancel()"
		[disabled]="isApproving"
	>
		<i class="bi bi-x-circle me-2"></i>
		Peruuta
	</button>
	<button
		type="button"
		class="btn btn-primary text-white"
		(click)="approve()"
		[disabled]="isLoading || isApproving"
	>
		<span
			*ngIf="isApproving"
			class="spinner-border spinner-border-sm me-2"
			role="status"
			aria-hidden="true"
		></span>
		<i *ngIf="!isApproving" class="bi bi-check-circle me-2"></i>
		{{ isApproving ? "Käsitellään..." : "Hyväksy" }}
	</button>
</div>
